
import styles from './Greeting.module.scss';

function Greeting() {
    return (
        <>
            <div className="components_wrap">
                <div className="cont_img_wrap">
                    <img src="/img/greeting8th.png" className='cont_img_de' alt="" style={{ width: '100%', }} />
                    <img src="/img/greeting8thM.png" className='cont_img_m' alt="" style={{ width: '100%', }} />
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>인사말</span>
                    </div>
                    <div className="cont_box">
                        <p>한국공학한림원은 대학, 기업 및 연구소 등에서 기술 발전에 현저한 공을 세운 공학기술인을 발굴하여 우대하고, 공학기술과 관련된 학술연구와 지원사업을 통해 국가의 창조적인 공학 기술 개발과 지속적인 발전에 기여하고자 설립되었습니다.</p>
                        <p>한국공학한림원은 대한민국 산업과 공학기술 발전을 위해 회원들의 지혜를 모으고, 공학기술계 리더그룹으로서 정부와 사회를 잇는 가교 역할에 충실할 것 입니다.</p>
                        <p>여러 토론회와 정책연구를 통해 산업, 공학기술과 관련된 사회적 이슈에 대해 바람직한 여론을 형성하고 건전한 정책을 발굴하는데 앞장설 것입니다.</p>
                        <p>대한민국의 미래는 훌륭한 과학기술 인재에 달려 있습니다.</p>
                        <p>한국공학한림원에서 추진하고 있는 주니어공학기술교실, 캠퍼스특허전략유니버시아드, 차세대 공대리더, 차세대 지식재산리더 등 인재 양성 사업을 활성화해 나가겠습니다. 학생들과 미래에 대한 비전을 공유하고, 공학기술인들이 여러 분야에서 자긍심을 가진 리더로서 국가에 기여할 수 있는 풍토를 만들어 가겠습니다.</p>
                        <p>한국공학한림원은 ‘국가와 인류의 지속적인 발전을 선도하는 글로벌 공학기술 플랫폼’을 비전으로 지속 가능한 성장사회, 스마트한 창조사회, 건강하고 안전한 행복사회를 만들어 가는데 선도적인 역할을 해 나갈 것입니다.</p>
                        <p>많은 관심과 지원을 부탁드립니다.</p>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>비전</span>
                    </div>
                    {/* <div className="cont_box">
                        <div className="cont_img_box">
                            <div className={`${styles.vi_txt} flex_center`}>
                                <img src="/img/vision_txt.gif" className='' alt="" />
                            </div>
                        </div>
                    </div> */}
                    <div className="cont_box">
                        <div>
                            <div className={`${styles.vi_txt} flex_center`}>
                                <span className={`${styles.vi_txt_span} f_family_NanumMyeongjo`}>혁신 대한민국을 위한 공학 싱크탱크</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>목표</span>
                    </div>
                    <div className="cont_box">
                        <ul className={`${styles.goal_list}`}>
                            <li className={`${styles.goal01}`}>
                                <span className={`${styles.goal_top_txt}`}>전환</span>
                                <span className={`${styles.goal_bot_txt}`}>미래 혁신 전략 수립</span>
                            </li>
                            <li className={`${styles.goal02}`}>
                                <span className={`${styles.goal_top_txt}`}>역량</span>
                                <span className={`${styles.goal_bot_txt}`}>공학 인재 육성 플랫폼 구축</span>
                            </li>
                            <li className={`${styles.goal03}`}>
                                <span className={`${styles.goal_top_txt}`}>참여</span>
                                <span className={`${styles.goal_bot_txt}`}>개방형 공학 커뮤니티 구축</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>전략과제</span>
                    </div>
                    <div className="cont_box">
                        <ul className={`${styles.goal_list02}`}>
                            <li className={`${styles.goal0201}`}>
                                <ul>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>01</strong>
                                        <p>산업/과학기술 혁신정책 발굴 및 제언</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>02</strong>
                                        <p>개방형 산학연 협업 생태계 조성</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>03</strong>
                                        <p>글로벌 기술 네트워크 주도</p>
                                    </li>
                                </ul>
                            </li>
                            <li className={`${styles.goal0202}`}>
                                <ul>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>04</strong>
                                        <p>회원 다양성 및 정체성 강화</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>05</strong>
                                        <p>혁신 공학 리더 발굴</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>06</strong>
                                        <p>차세대 공학인재 육성 생태계 구축</p>
                                    </li>
                                </ul>
                            </li>
                            <li className={`${styles.goal0203}`}>
                                <ul>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>07</strong>
                                        <p>국민 공감 공학 콘텐츠 창작</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>08</strong>
                                        <p>혁신 가치 창출 플랫폼 운영</p>
                                    </li>
                                    <li className={`${styles.goal_st}`}>
                                        <strong>09</strong>
                                        <p>국민 참여형 정책 혁신 추진</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="cont_wrap">
                    <div className="cont_tit_box">
                        <span>핵심 가치</span>
                    </div>
                    <div className="cont_box">
                        <div className="cont_img_box">
                            <img src="/img/vision.jpg?v=1" className='cont_img_de' alt="" style={{ width: '100%' }} />
                            <img src="/img/vision_m.jpg?v=1" className='cont_img_m' alt="" style={{ width: '100%', }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Greeting;